import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const getPricingProductRowKey = (pro) =>
    pro?.ulid || `pricing-product-${pro?.product_ulid || 'new'}-${pro?.global_calorific_value ?? 'empty'}`;

export const getPastPricingRowKey = (pro) =>
    pro?.ulid || `${pro?.user_name}-${pro?.updated_at}-${pro?.payload?.old_soft_rate}-${pro?.payload?.new_soft_rate}`;

export const handlePricingCancelEdit = ({
    index,
    newRowIndexes,
    setNewRowIndexes,
    setEditIndex,
    setFieldValue,
    originalValues,
}) => {
    if (newRowIndexes.includes(index)) {
        setEditIndex(null);
        setNewRowIndexes(newRowIndexes.filter((i) => i !== index));
        return;
    }
    setFieldValue(`products[${index}]`, originalValues);
    setEditIndex(null);
};

export const handlePricingRemoveProduct = ({
    index,
    remove,
    selectedProducts,
    setSelectedProducts,
    productUlid,
}) => {
    remove(index);
    setSelectedProducts(selectedProducts.filter((p) => p !== productUlid));
};

export const PricingProductRow = ({
    pro,
    index,
    editIndex,
    setEditIndex,
    setOriginalValues,
    formikProps,
    rfqMang,
    selectedProducts,
    handleProductChange,
    newRowIndexes,
    setNewRowIndexes,
    originalValues,
    remove,
    setSelectedProducts,
}) => {
    const isEditing = editIndex === index;
    const productName =
        rfqMang.allProductList.find((product) => product.ulid === pro.product_ulid)?.name || 'Select Option';

    return (
        <tr className='mt-2'>
            <td className='col-3'>
                {isEditing ? (
                    <Field
                        as='select'
                        name={`products[${index}].product_ulid`}
                        className='form-control font-b2'
                        onChange={(e) => handleProductChange(e, index, formikProps.setFieldValue)}>
                        <option value='' label='Select Option' />
                        {rfqMang.allProductList.map((product) => (
                            <option
                                key={product.ulid}
                                value={product.ulid}
                                label={product.name}
                                disabled={selectedProducts?.includes(product.ulid)}
                            />
                        ))}
                    </Field>
                ) : (
                    <span>{productName}</span>
                )}
                <ErrorMessage
                    name={`products[${index}].product_ulid`}
                    component='div'
                    className='error-message font-b3 text-error-700'
                />
            </td>
            <td className='col-2'>
                {isEditing ? (
                    <Field
                        type='number'
                        name={`products[${index}].global_calorific_value`}
                        className='form-control font-b2'
                    />
                ) : (
                    <span>{pro.global_calorific_value || 'Enter Value'}</span>
                )}
                <ErrorMessage
                    name={`products[${index}].global_calorific_value`}
                    component='div'
                    className='error-message font-b3 text-error-700'
                />
            </td>
            <td className='col-1 text-center'>
                {isEditing ? (
                    <>
                        <span
                            className={`sf-check pe-3 font-dh4 cursor border-right`}
                            onClick={() => setEditIndex(null)}></span>
                        <span
                            className='sf-error ps-3 font-dh4 cursor'
                            onClick={() =>
                                handlePricingCancelEdit({
                                    index,
                                    newRowIndexes,
                                    setNewRowIndexes,
                                    setEditIndex,
                                    setFieldValue: formikProps.setFieldValue,
                                    originalValues,
                                })
                            }></span>
                    </>
                ) : (
                    <>
                        <span
                            className={`sf-edit pe-3 font-dh4 cursor ${
                                formikProps.values.products.length > 1 ? 'border-right' : ''
                            }`}
                            onClick={() => {
                                setEditIndex(index);
                                setOriginalValues({
                                    ...formikProps.values.products[index],
                                });
                            }}></span>
                        {formikProps.values.products.length > 1 && (
                            <span
                                className='sf-delete ps-2 font-dh4 cursor'
                                onClick={() =>
                                    handlePricingRemoveProduct({
                                        index,
                                        remove,
                                        selectedProducts,
                                        setSelectedProducts,
                                        productUlid: formikProps.values.products[index].product_ulid,
                                    })
                                }></span>
                        )}
                    </>
                )}
            </td>
        </tr>
    );
};
